<h4 class="mb-10">Sync mortgage instructions with your matter</h4>

<app-step-progress-nav
	[steps]="steps"
	[current]="current"
	(stepClicked)="current = $event"
	[clickable]="true"
></app-step-progress-nav>

<app-llc-borrowers-sync
	*ngIf="current === 0"
	(next)="current = 1"
	[transaction]="transaction"
></app-llc-borrowers-sync>
<app-llc-sync-data
	*ngIf="current === 1"
	(next)="goToMortgage()"
	[transaction]="transaction"
	[showPriceOveride]="true"
></app-llc-sync-data>
